// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WqQ4L","content":"styles_content__37NnL"};